import { rootKeys } from '@axo/shared/data-access/hooks';
import { ace_index } from '@axo/shared/data-access/types';

export interface ISearchQueryKeyParams {
  query: ace_index.FindInput;
}

export const searchQueryKeys = {
  root: (params: ISearchQueryKeyParams) =>
    [...rootKeys.searchIndex(), 'search query', params.query] as const,
};

export function parseSearchQueryKey<T extends keyof typeof searchQueryKeys>(
  queryKey: ReturnType<(typeof searchQueryKeys)[T]>
): ISearchQueryKeyParams {
  const [, , query] = queryKey;

  return { query };
}
